import { Component, Injector, Input, OnInit } from '@angular/core';
import { IManagableObject } from "../../../IManagableObject";
import { BaseComponentWithDialog } from "../../../base-admin-panel/base-component-with-dialog";
import { DriversViewModel } from "../../models/DriversViewModel";
import { KeyViewModel } from "../../../Keys/Model/KeyViewModel";
import { KeysService } from '../../../../../services/keys.service';

@Component({
    selector: 'app-driver-group-mgmt',
    templateUrl: './driver-group-mgmt.component.html',
    styleUrls: ['./driver-group-mgmt.component.css'],
    standalone: false
})
export class DriverGroupMgmtComponent extends BaseComponentWithDialog implements OnInit {

  @Input()
  public model: DriversViewModel;
  @Input()
  public groups: IManagableObject[] = [];

  @Input('keys')
  set onKeysSet(val) {
    this.keys = val;
    this.FreeKeys = this.keys.filter(k => (<KeyViewModel>k).DriverId == 0) as IManagableObject[];
    this.model.Keys = this.keys.filter(k => (<KeyViewModel>k).DriverId == this.model.Id).map(x => x.Id);
  }

  public keys: IManagableObject[] = [];
  public KeyGroups: IManagableObject[] = [];

  FreeKeys: IManagableObject[] = [];
  private keysService: KeysService;

  constructor(protected injector: Injector) {
    super(injector);
    this.keysService = injector.get(KeysService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.keysService.GetGroups()
      .subscribe(groups => {
        this.KeyGroups = groups;
      });
  }
}
